import React from 'react'
import classNames from 'classnames'
import { Link, LinkProps } from 'react-router-dom'

const logo = '/images/logo.png'

/** Context where the logo is rendered, controls surrounding layout classes */
type LogoPlacement = 'navbar-vertical' | 'navbar-top' | 'auth'

interface LogoProps extends Omit<LinkProps, 'to'> {
    /** Placement context — controls Bootstrap layout classes applied */
    at?: LogoPlacement
    /** Width of the logo image in pixels */
    width?: number
    /** Extra CSS classes on the inner wrapper div */
    className?: string
}

/**
 * Site logo rendered as a `Link` to `/`.
 * Layout classes adapt automatically to the given `at` placement context.
 */
const Logo = ({
    at = 'auth',
    width = 58,
    className,
    ...rest
}: LogoProps) => (
    <Link
        to='/'
        className={classNames(
            'text-decoration-none',
            { 'navbar-brand text-left': at === 'navbar-vertical' },
            { 'navbar-brand text-left': at === 'navbar-top' },
        )}
        {...rest}
    >
        <div
            className={classNames(
                'd-flex',
                {
                    'align-items-center py-3': at === 'navbar-vertical',
                    'align-items-center': at === 'navbar-top',
                    'flex-center font-weight-extra-bold fs-5 mb-4': at === 'auth',
                },
                className,
            )}
        >
            <img className='mr-2' src={logo} alt='Logo' width={width} />
        </div>
    </Link>
)

export default Logo
